import { overlay_default } from './defaults';
import { Overlay } from './types';

export const updateOverlayState = <K extends keyof Overlay>(
  state: Overlay,
  key: K,
  data: Partial<Overlay[K]>
) => {
  const newState = { ...state };
  newState[key] = { ...newState[key], ...data };
  return newState;
};

export const clearOverlayState = <K extends keyof Overlay>(state: Overlay, key: K) => {
  const newState = { ...state };
  newState[key] = overlay_default[key] as Overlay[K];
  return newState;
};
